/**
 * @name Company Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

// #region common
import API from '../config';

const base = `${API.BASE_DEV_HOST}/api/companies`;

export const updateById = (companyId: number) => `${base}/${companyId}`;
export const getCapTableList = (
  companyId: string,
  {
    companyMeasurementDateId,
    measurementDateId,
  }: {
    companyMeasurementDateId?: string;
    measurementDateId?: string;
  }
) => {
  let query = '';
  if (measurementDateId) {
    query += `mp=${measurementDateId}`;
  }
  if (companyMeasurementDateId) {
    query += `cmd=${companyMeasurementDateId}`;
  }

  return `${base}/${companyId}/cap-tables?${query}`;
};
// mp = measurement period - legacy concept which is now called measurement date
export const getCompanySummary = (companyId: number, measurementDateId?: number) =>
  `${base}/${companyId}/summary/${measurementDateId ?? ''}`;
export const hasCompanySummary = (companyId: number, measurementDateId?: number) =>
  `${base}/${companyId}/has-summary/${measurementDateId ?? ''}`;
export const getFundsByCompanyId = (companyId: string) => `${base}/${companyId}/funds`;
export const getVersionsByCompanyIdByDateId = (companyId: number, dateId: number, includeConvNotes: boolean) =>
  `${base}/${companyId}/cap-tables?mp=${dateId}&include_convertible_notes=${includeConvNotes}`;
export const getAllocationsVersionsByCompanyIdByDateId = (companyId: string, dateId: string) =>
  `${base}/${companyId}/allocations?mp=${dateId}`;
export const getQuarterEndsByCompanyId = (companyMeasurementDateId: string) =>
  `${base}/fiscal-end-dates/${companyMeasurementDateId}`;
export const deleteCompany = (companyId: string) => `${base}/${companyId}`;
export const getAllocationValuesByCompanyId = (companyId: string, measurementDateId: string, version: string) =>
  version
    ? `${base}/${companyId}/allocation-values?md=${measurementDateId}&version=${version}`
    : `${base}/${companyId}/allocation-values?md=${measurementDateId}`;
export const getCompanyMetric = (companyId: number, metricName: string, measurementDateSlug?: string) => {
  const url = `${base}/${companyId}/metrics/${metricName}`;
  if (!measurementDateSlug) return url;

  // Extract date from slug "2015-01-01-198" → "2015-01-01"
  const dateOnly = measurementDateSlug.split('-').slice(0, 3).join('-');
  return `${url}?measurement_date=${dateOnly}`;
};
